import { Button, Center, Stack, Text, Title } from '@mantine/core'
import { Component, type ReactNode } from 'react'

interface State {
  broken: boolean
}

/**
 * Catches a render crash anywhere below it and shows a plain "Something went wrong" screen instead of a blank
 * page or a white screen of death — with Reload and Go home, and no stack trace shown to anyone (the project logs
 * nothing extra, owner decision). Wraps the whole app once, in main.tsx's Shell.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { broken: false }

  static getDerivedStateFromError(): State {
    return { broken: true }
  }

  render() {
    if (!this.state.broken) return this.props.children
    return (
      <Center mih="100vh" p="md">
        <Stack gap="md" maw={420} align="center" ta="center">
          <Title order={1} fz={24}>
            Something went wrong
          </Title>
          <Text size="sm" c="dimmed">
            Macrotide hit a problem and couldn&apos;t continue. Reloading usually fixes it.
          </Text>
          <Stack gap="xs" w="100%">
            <Button onClick={() => window.location.reload()} fullWidth>
              Reload
            </Button>
            <Button variant="subtle" color="gray" component="a" href="/today" fullWidth>
              Go home
            </Button>
          </Stack>
        </Stack>
      </Center>
    )
  }
}
